import React, { Component } from "react";
import { array, shape } from "prop-types";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import qs from "qs";
import { sessionCheck } from "src/actions/user";
import Prioritize from "../";
import BlueHeader from "../BlueHeader";
import {
  getCurrentCollection,
  getResultsForCollection,
} from "src/actions/prioritize";
import Content from "src/pages/Prioritize/Participate/Content";
import CreativeView from "src/pages/Prioritize/Results/CreativeView";
import TableView from "src/pages/Prioritize/Results/TableView";
import collectionApi from "src/api/v2/CollectionApi";
import "./Results.scss";
import Header from "../Header";
import { Button, Tooltip } from "src/components/shared";
import { getParticipateURL } from "src/util/PrioritizeUtil";
import LoadingAndPulse from "src/components/shared/LoadingAndPulse";

class Results extends Component {
  constructor(props) {
    super(props);

    this.getViewModeFromURL = this.getViewModeFromURL.bind(this);
    this.getCollectionIdFromURL = this.getCollectionIdFromURL.bind(this);

    this.state = {
      collectionId: this.getCollectionIdFromURL(),
      currentTabIdx: 0,
      viewMode: this.getViewModeFromURL(),
      result: [],
    };
  }

  fetchResults = async () => {
    const { collection, getResultsForCollection } = this.props;

    if (collection && collection.id) console.log("fetchResults", collection);

    collectionApi
      .getResult(collection.id)
      .then((results) => getResultsForCollection(results));
  };

  componentDidMount = () => {
    this.fetchResults();
  };

  componentDidUpdate = () => {
    console.log("Results componentDidUpdate", this.props);
    const URLviewMode = this.getViewModeFromURL();
    const { viewMode } = this.state;
    const { collection, results } = this.props;

    if (collection.id && !results.length) this.fetchResults();

    if (viewMode !== URLviewMode)
      this.props.history.push({
        search: this.updateQueryValue("view", viewMode),
      });
  };

  componentWillUnmount = () => {};

  onViewModeChange = (viewMode) => () => {
    this.setState({ viewMode });
  };

  onNavClick = () => {};

  getCollectionIdFromURL = () => {
    const { pathname } = this.props.location;
    const patharray = pathname.split("/");
    console.log("patharray", patharray);
    return patharray && patharray.length > 3 ? patharray[3] : null;
  };

  getViewModeFromURL = () => {
    const { location } = this.props;
    const DEFAULT_VIEW = "table";
    if (!location.search) return DEFAULT_VIEW;
    const possibleViews = ["table", "creative"];
    const qsObject = qs.parse(location.search, { ignoreQueryPrefix: true });
    if (!qsObject || !qsObject.view || !possibleViews.includes(qsObject.view))
      return DEFAULT_VIEW;

    return qsObject.view;
  };

  updateQueryValue = (key, newValue) => {
    const { location } = this.props;
    const keyValuePairs = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    keyValuePairs[key] = newValue;
    const newQuery = qs.stringify(keyValuePairs);
    return newQuery;
  };

  onParticipateClick = () => {
    const { history, location } = this.props;
    history.push(`${getParticipateURL(location.pathname)}`);
  };

  render() {
    const { viewMode } = this.state;
    const { collection, results, collectionLoading, comments } = this.props;

    const sortByRank = (a, b) => {
      if (a.avg_weighted_score > b.avg_weighted_score) return -1;
      if (a.avg_weighted_score < b.avg_weighted_score) return 1;
      return 0;
    };

    const sortedResult = [...results].sort(sortByRank);

    return (
      <Prioritize step={4} onNavClick={this.onNavClick} collection={collection}>
        <Header>
          <div className="prioritize__header-menu">
            <Button
              className="btn-lg btn-secondary"
              onClick={this.onParticipateClick}
            >
              <Tooltip tooltip="Participate in this POPin" placement="bottom">
                <i className="material-icons">chevron_left</i> Participate
              </Tooltip>
            </Button>
          </div>
          <h1>{"Prioritize Results"}</h1>
        </Header>

        <div className="participate">
          <BlueHeader subtitle={""} title={collection.title} />
          {collectionLoading ? (
            <LoadingAndPulse
              size={10}
              color="#B8BAC7"
              whatIsLoading="activity"
            />
          ) : (
            <Content noHeader>
              <div style={{textAlign: 'center'}}>
                <div className="summary_container">
                  <div className="summary">
                    <h2>PARTICIPATION</h2>
                    <label>{collection.participant}</label>
                  </div>
                  <div className="vertical_divider"></div>
                  <div className="summary">
                    <h2>COMPLETION</h2>
                    <label>{collection.participant > 0 ? `${parseInt(collection.completed / collection.participant * 100)}%` : '-'}</label>
                  </div>
                </div>
              </div>

              <br/>
              <br/>

              {viewMode === "table" ? (
                <TableView
                  collection={collection}
                  withHeader
                  data={sortedResult}
                  comments={comments}
                />
              ) : (
                <CreativeView data={collection.children} />
              )}
            </Content>
          )}
        </div>
      </Prioritize>
    );
  }
}

Results.propTypes = {
  results: array,
  comments: shape({}),
  collection: shape({
    children: array,
  }),
};

Results.defaultProps = {
  results: [],
  comments: {},
  collection: { children: [] },
};

const mapStateToProps = (state) => {
  return {
    collection: state.prioritize.collection,
    results: state.prioritize.results,
    collectionLoading: state.prioritize.collectionLoading,
    comments: state.prioritize.comments,
  };
};

export default withRouter(
  connect(mapStateToProps, {
    sessionCheck,
    getCurrentCollection,
    getResultsForCollection,
  })(Results)
);
